import { useEffect, useState } from "react";
import { UtensilsCrossed, Phone, MapPin } from "lucide-react";
import { ChiamaCameriere } from "@/components/ChiamaCameriere";

/** Carta digitale pubblica: è quello che vede il cliente inquadrando il QR sul tavolo. */
export default function Carta() {
  const slug = window.location.pathname.split("/").filter(Boolean)[1] || "";
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/carta/${slug}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setD)
      .catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="grid min-h-screen place-items-center bg-slate-950 p-8 text-center text-slate-300">Menu non disponibile.</div>;
  if (!d) return <div className="grid min-h-screen place-items-center bg-slate-950 text-slate-400">Un istante…</div>;

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100" data-testid="carta-page">
      <div className="mx-auto max-w-2xl px-5 py-10">
        <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-amber-400">Il nostro menu</p>
        <h1 className="font-head mt-2 text-4xl font-bold sm:text-5xl">{d.name}</h1>
        <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-xs text-slate-400">
          {d.address && <span className="flex items-center gap-1"><MapPin className="h-3 w-3" /> {d.address}</span>}
          {d.phone && <a href={`tel:${d.phone}`} className="flex items-center gap-1 hover:text-amber-400"><Phone className="h-3 w-3" /> {d.phone}</a>}
        </div>

        {d.menu_fisso && (
          <div className="mt-8 rounded-xl border border-amber-500/30 bg-amber-500/10 p-5" data-testid="carta-menu-fisso">
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-400">{d.menu_fisso.name}</p>
            <p className="font-num mt-1 text-2xl font-bold">
              {d.menu_fisso.price_full.toFixed(2)} €
              <span className="ml-2 text-sm font-normal text-slate-300">
                completo · {d.menu_fisso.price_light.toFixed(2)} € ridotto
              </span>
            </p>
            {["primi", "secondi", "contorni"].map((k) => (
              (d.menu_fisso[k] || []).length > 0 && (
                <p key={k} className="mt-1.5 text-sm text-slate-200">
                  <span className="text-amber-300">{k === "primi" ? "Primi" : k === "secondi" ? "Secondi" : "Contorni"}:</span>{" "}
                  {d.menu_fisso[k].join(" · ")}
                </p>
              )
            ))}
          </div>
        )}

        <div className="mt-10 space-y-9">
          {d.categorie.map((c) => (
            <section key={c.name} data-testid={`carta-cat-${c.name}`}>
              <h2 className="font-head flex items-center gap-2 border-b border-slate-800 pb-2 text-base font-bold text-amber-400 md:text-lg">
                <UtensilsCrossed className="h-4 w-4" /> {c.name}
              </h2>
              <ul className="mt-3 space-y-3">
                {c.piatti.map((p) => (
                  <li key={p.name} className="flex items-start justify-between gap-4">
                    <div className="min-w-0">
                      <p className="text-sm font-semibold text-slate-100">{p.name}</p>
                      {p.description && <p className="text-xs text-slate-400">{p.description}</p>}
                      {p.allergens?.length > 0 && (
                        <p className="mt-0.5 text-[10px] uppercase tracking-wide text-slate-500">
                          allergeni: {p.allergens.join(", ")}
                        </p>
                      )}
                    </div>
                    <span className="font-num shrink-0 text-sm font-bold text-slate-100">{p.price.toFixed(2)} €</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <p className="mt-12 border-t border-slate-800 pt-5 text-[11px] text-slate-500">
          Menu sempre aggiornato · gestito con Reprehendo
        </p>

        {d.chiamate && (d.richieste || []).length > 0 && (
          <ChiamaCameriere slug={slug} richieste={d.richieste} tavoli={d.tavoli || []} />
        )}
      </div>
    </div>
  );
}
